/**
 * Sizes as the download surfaces show them (VE-26426).
 *
 * Separate from `formatFileSize` in @utils, which renders two decimals and is
 * used by Download Review and the media page. Two decimals is more precision
 * than a moving progress line can use, and the extra characters were enough to
 * truncate the toast; but changing the shared helper would restyle screens this
 * ticket has no business touching.
 */
const KB = 1024;
const MB = KB * 1024;
const GB = MB * 1024;

const unitFor = (bytes: number) => {
  if (bytes >= GB) {
    return { label: 'GB', size: GB };
  }
  if (bytes >= MB) {
    return { label: 'MB', size: MB };
  }
  return { label: 'KB', size: KB };
};

/** One decimal place — the second never told the user anything. */
export const formatDownloadSize = (bytes: number): string => {
  const unit = unitFor(bytes);
  return `${(bytes / unit.size).toFixed(1)} ${unit.label}`;
};

/**
 * How far through one transfer is: `34.3 / 55.6 MB`.
 *
 * Both halves are shown in the total's unit and the unit is named once, rather
 * than `432.1 KB / 55.6 MB` — the same figure, two units and eight characters
 * longer, in a line that has to fit.
 */
export const formatDownloadProgress = (
  loaded: number,
  total: number
): string => {
  const unit = unitFor(total);
  const done = (Math.min(loaded, total) / unit.size).toFixed(1);
  return `${done} / ${(total / unit.size).toFixed(1)} ${unit.label}`;
};
